import {
  AfterViewInit,
  Component,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { Router } from "@angular/router";
import { PictureThePossibilitiesService } from "src/app/core/services/creatics/ptp/picture-the-possibilities.service";
import Talk from "talkjs";

@Component({
  selector: "app-community-chat-mobile",
  templateUrl: "./community-chat-mobile.component.html",
  styleUrls: ["./community-chat-mobile.component.css"],
})
export class CommunityChatMobileComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  private session!: Talk.Session;
  private chatbox: Talk.Chatbox | null = null;

  @Input() eventId: string = "communityChat123";
  @Input() eventDetails: any;

  userId: any;
  userDetails: any;
  isUserLoggedIn: boolean = false;

  checkMobile: boolean = this.isMobile();
  private resizeTimeout: any;

  constructor(
    private pictureThePossibilitiesService: PictureThePossibilitiesService,
    private router:Router
  ) { }

  ngOnInit(): void {
    this.initializeChatSession();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.eventId || changes.eventDetails) {
      if (this.eventId && this.eventDetails) {
        this.reinitializeChatbox();
      }
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.mountChatbox();
    }, 3000)
  }

  ngOnDestroy(): void {
    this.destroyChatbox();
  }

  private async initializeChatSession(): Promise<void> {
    await Talk.ready;

    this.pictureThePossibilitiesService
      .fetchTalkJsMetadata()
      .toPromise()
      .then((res: any) => {
        this.userDetails = res;
        this.userId = res.userID;
        this.isUserLoggedIn = true;

        const me = new Talk.User({
          id: this.userId,
          name: this.userDetails.userName,
          email: this.userDetails.userEmail,
          photoUrl: this.userDetails.userProfileImage,
          role: "Showcase_UI",
        });

        this.session = new Talk.Session({
          appId: this.userDetails.appId,
          me: me,
          signature: this.userDetails.signature,
        });

        this.initializeConversation();
      })
      .catch((err) => {
        this.isUserLoggedIn = false;
        console.error("Error fetching TalkJS metadata:", err);
      });
  }

  private initializeConversation(): void {
    const conversation = this.session.getOrCreateConversation(this.eventId);
    conversation.setAttributes({
      subject: this.eventDetails?.name || "Default",
      photoUrl:
        this.eventDetails?.image || "https://example.com/default-image.jpg",
    });
    const me = this.session.me;
    conversation.setParticipant(me);
    this.chatbox = this.session.createChatbox();
    this.chatbox.select(conversation);
    setTimeout(() => {
      this.mountChatbox();
    }, 2000)
  }

  @HostListener("window:resize", ["$event"])
  onResize(): void {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      const isNowMobile = this.isMobile();
      if (this.checkMobile !== isNowMobile) {
        this.checkMobile = isNowMobile;
        console.log("Resizing detected. Reinitializing chatbox...");
        this.reinitializeChatbox();
      }
    }, 300);
  }

  private reinitializeChatbox(): void {
    this.destroyChatbox();
    if (this.session) {
      this.initializeConversation();
    }
  }

  private destroyChatbox(): void {
    if (this.chatbox) {
      console.log("Destroying chatbox...");
      this.chatbox.destroy();
      this.chatbox = null;
    }
  }

  private mountChatbox(): void {
    if (this.chatbox) {
      const containerId =  "showcaseTalkjsContainerMobile"
      console.log("Mounting chatbox to container:", containerId);
      setTimeout(()=>{
        const container = document.getElementById(containerId);
        if (container) {
          this.chatbox?.mount(container);
        } else {
          console.error("Container not found:", containerId);
        }
      },5000)
    }
  }


  private isMobile(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor;
    return /Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(userAgent);
  }

  onUserNotLoggedIn() {
    console.log(this.router.url)
    location.href = `/login?referer=${this.router.url.substring(1)}`
  }
}
